export const SAVE_INTEGRATION = "x/marketplace/integration/SAVE_INTEGRATION";
export const saveIntegration = data => ({
    type: SAVE_INTEGRATION,
    payload: data
});